
var User_Id = $("#instafeed").data("user_id");
var Access_Token = $("#instafeed").data("access_token");
var limit = $("#instafeed").data("limit");


var userFeed = new Instafeed({
  get: 'user',
  userId: User_Id,
  accessToken: Access_Token,
  limit: limit,
  resolution: 'thumbnail',
  template: '<a href="{{link}}" target="_blank" class="insta_item"><div class="insta_overlay"><ul><li><span><i class="entypo-heart"></i></span> {{likes}}</li><li><span><i class="entypo-comment"></i></span> {{comments}}</li></ul></div><img src="{{image}}"></a>'
});

userFeed.run();

$(window).load(function(e) {
  insta_slider();
});
$(window).resize(function(e) {
  insta_slider();
});

function insta_slider(){
  $('.instafeed_small .insta_item').css('height', $('.instafeed_small .insta_item').width());
}